import React from "react"
import { useTranslation } from "react-i18next"

const Manual = () => {
  const { t } = useTranslation()

  const frameUrl = "https://sway.office.com/s/iy0WIFMDCi29PR4A/embed"

  return (
    <>
      <h1 className="mb-5">{t("Manual")}</h1>
      <iframe
        title={t("Dashboards")}
        src={frameUrl}
        className="srs-iframe srs-iframe--sway"
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
        sandbox="allow-forms allow-modals allow-orientation-lock allow-popups allow-same-origin allow-scripts"
        scrolling="no"
        allowFullScreen
      />
    </>
  )
}

export default Manual
